import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Create } from '@material-ui/icons';
import isMobile from 'ismobilejs';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: isMobile.phone ? 'calc(90%)' : '170px',
    borderBottom: 0,
  },
  selectItem: {
    fontSize: 14,
  },
});
class TrackingNumber extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trackingNumber: props.trackingNumber,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      trackingNumber: nextProps.trackingNumber,
    });
  }
  handleChange(value) {
    this.setState({ trackingNumber: value });
  }

  render() {
    const { classes, setTrackingNumber, order, withLabel, readOnly } = this.props;
    const { trackingNumber } = this.state;
    return (
      <TextField
        disabled={!!readOnly || order.shippingStatusLabel === 'cancelled'}
        placeholder="Tracking Number"
        className={classes.textField}
        margin="normal"
        value={trackingNumber || ''}
        onChange={e => this.handleChange(e.target.value)}
        onBlur={e => setTrackingNumber(order, e.target.value)}
        label={withLabel ? 'Tracking Number' : ''}
        InputProps={{
          className: classes.selectItem,
          startAdornment: (
            <InputAdornment position="start">
              <Create />
            </InputAdornment>
          ),
        }}
      />
    );
  }
}

TrackingNumber.propTypes = {
  classes: PropTypes.object.isRequired,
  setTrackingNumber: PropTypes.func.isRequired,
  trackingNumber: PropTypes.string,
  order: PropTypes.object.isRequired,
  withLabel: PropTypes.bool,
  readOnly: PropTypes.boolean,
};

export default withStyles(styles)(TrackingNumber);



// WEBPACK FOOTER //
// ./src/components/orders/TrackingNumber.js